<div class="section intro">
    <!--<div *ngIf="clickedWeek" keypressDirective (onKeyPressed)="handleKeyPressed($event, clickedWeek)">-->
    <div *ngIf="clickedWeek">
        <div *ngIf="realWeekNumber || clickedWeek?.weekNumber" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <i class="material-icons" (click)="onPreviousWeekClicked(clickedWeek)">
                    arrow_left
                </i>
            </div>
            <div>
                <h3>{{ 'Week_number'|translate:{'weekNumber': realWeekNumber || clickedWeek.weekNumber} }}</h3>
                <span *ngIf="realWeekNumber">{{ firstDayOfWeek|appDate:'dd.MM.yy' }} - {{ lastDayOfWeek|appDate:'dd.MM.yy' }}</span>
            </div>
            <div>
                <i class="material-icons" (click)="onNextWeekClicked(clickedWeek)">
                    arrow_right
                </i>
            </div>
        </div>
        
        <div *ngIf="!realWeekNumber && !clickedWeek?.weekNumber">
            <h3>{{ 'NoWeekSelected'|translate }}</h3>
        </div>
    </div>
    <div *ngIf="!clickedWeek">
        <h3>{{ annualPlan.title }}</h3>
    </div>
</div>
<ng-container>
    <div class="section">
        <p *ngIf="!clickedWeek">{{ 'SelectWeekToStartEditing'|translate }}</p>
        <app-annual-plan-form-week
            [organization]="organization"
            [annualPlan]="annualPlan"
            [weeks]="weeks"
            [clickedWeek]="clickedWeek"
            (weekToUpdateEvent)="weekUpdated($event)"
            (weekFormEvent)="weekFormEvent($event)"
            *ngIf="clickedWeek"></app-annual-plan-form-week>
    </div>
    <!--
    <div class="section pt-0" *ngIf="clickedWeek">
        <p><strong>{{ 'ProTip'|translate }}</strong> {{ 'ProTipPressNPToNavigate'|translate }}</p>
    </div>
    -->
</ng-container>
